export default {
	apiKey: 'AIzaSyDZwd-cB_dseqypRoUipg4PdfYIraEO9Jk',
	authDomain: 'jindamhair.firebaseapp.com',
	projectId: 'jindamhair',
	storageBucket: 'jindamhair.appspot.com',
	messagingSenderId: '783409984758',
	appId: '1:783409984758:web:b3d7ac266775a5d12fe8d7',
	measurementId: 'G-GYD9KGXW3C',
};
